module.exports = __webpack_public_path__ + "static/img/brees-2005-slide-1.d407026.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/brees-2005-slide-1.jpg
// module id = v3cA
// module chunks = 1